import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'lib-full-screen',
  templateUrl: './full-screen.component.html',
  styleUrl: './full-screen.component.css'
})
export class FullScreenComponent {
  routerNavSubcribe: any;
  type: any = 'login'
  constructor(private route: Router, private activeRoute: ActivatedRoute) {

  }
  ngOnInit() {
    this.routerNavSubcribe = this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let type = this.activeRoute.snapshot.paramMap.get('type');
        if (type != this.type) {
          this.type = type
        }
      }
    });
    this.type = this.activeRoute.snapshot.paramMap.get('type');
  }
}
